import React from 'react';
import * as ReactDOM from 'react-dom';
import {inject, observer} from 'mobx-react';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import styles from './style.css';

const NotificationsModal = inject('notificationsStore')(observer(
    function NotificationsModal({notificationsStore}) {
        const classNames={
            enter: styles.animatedEnter,
            enterActive: styles.animatedEnterActive,
            exit: styles.animatedExit,
            exitActive: styles.animatedExitActive,
        }
        const onWindowClick = (event) => {
          event.stopPropagation()
        }
        let notifications = notificationsStore.activeNotifications;
        return ReactDOM.createPortal((

            <TransitionGroup className={styles.modalContainer} >
                {notifications.map(n => {
                    return (
                        <CSSTransition
                            key={n.id}
                            timeout={1500}
                            classNames={classNames}
                        >
                            <div className={styles.messageContainer}>
                                <div className={styles.message}
                                     onClick={onWindowClick}
                                     title={n.message}
                                >
                                    <div className={styles.content}>
                                        {n.message}
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                )})}
            </TransitionGroup>
            ),
            document.getElementById('notificationsModal')
        );
    }
))

export default NotificationsModal;


// WEBPACK FOOTER //
// ./src/components/NotificationsModal/index.js